import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchPortfolioData = createAsyncThunk("portfolio/fetchPortfolioData", async () => {
  const res = await fetch("https://api.npoint.io/e2043770421e0b790596"); // replace with your link
 if (!res.ok) throw new Error("Failed to fetch data");

    const json = await res.json(); // ✅ parse once
    console.log("Data fetched successfully, status:", res.status);
    return json; // ✅ 
});

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState: {
    loading: true,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPortfolioData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPortfolioData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPortfolioData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default portfolioSlice.reducer;
